// Build version - updated to force cache invalidation
export const BUILD_VERSION = '2025-11-26-i18n-codemod';
export const FEATURES = {
  DARK_MODE: true,
  DARK_MODE_VARIANTS: true,
  DARK_MODE_GLOBAL_CSS: true,
  NOTIFICATIONS: true,
  NOTIFICATION_PORTAL: true,
  TOOLTIP_FIXED: true,
  DESKTOP_NOTIFICATIONS: true,
};
